import React from "react";
import { Link } from "react-router-dom";
import "../components/ErrorPages.css";

const NotFound = () => {
  return (
    <div className="notfound-body center-section text-center">
      <div className="container mt-5">
        <div className="row">
          <div className="col-md-6">
        {/* Left Content */}
        <div className="content">
          <h1>500</h1>
          <h2>Internal Server Error</h2>
          <p>
            Oops! Something went wrong on our end.
            Our server is having a little trouble right now.
            Please try again later or contact CodeInputs support.
          </p>

          <div className="buttons">
            <Link to="/" className="btn btn-primary me-3">Go to Home</Link>
            <Link to="/contact" className="btn btn-outline">Contact Us</Link>
          </div>
        </div>
      </div>

        {/* Right Illustration */}
      <div className="col-md-6">
        <div className="illustration">
          {/* You can replace this with SVG component also */}
          <img className="responsive-img"
            src="/graphics/images/500illustration.svg"
            alt="Internal Server Error"
          />
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default NotFound;
